import script from "./AddAddressView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAddressView.vue?vue&type=script&setup=true&lang=js"

import "./AddAddressView.vue?vue&type=style&index=0&id=80f42320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80f42320"]])

export default __exports__